var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 9,
    viewBox: "0 0 13 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.854 0.854028L4.85403 8.85403C4.80759 8.90052 4.75245 8.9374 4.69175 8.96256C4.63105 8.98772 4.56599 9.00067 4.50028 9.00067C4.43457 9.00067 4.36951 8.98772 4.30881 8.96256C4.24811 8.9374 4.19296 8.90052 4.14653 8.85403L0.646528 5.35403C0.552708 5.26021 0.5 5.13296 0.5 5.00028C0.5 4.8676 0.552708 4.74035 0.646528 4.64653C0.740348 4.55271 0.867596 4.5 1.00028 4.5C1.13296 4.5 1.26021 4.55271 1.35403 4.64653L4.50028 7.7934L12.1465 0.146528C12.2403 0.0527074 12.3676 -9.88557e-10 12.5003 0C12.633 9.88558e-10 12.7602 0.0527074 12.854 0.146528C12.9478 0.240348 13.0006 0.367596 13.0006 0.500278C13.0006 0.63296 12.9478 0.760208 12.854 0.854028Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.7fefe06823c3985323d60cb155f859c1.svg";
export { ForwardRef as ReactComponent };